import { Box } from "@mui/material"

const validateData = (data) => {

    const response = []


    if (data?.nome_rota_regiao === '')
        response.push(<Box>Digite o nome da rota/região.</Box>)

    if (data?.id_tipo === null)
        response.push(<Box>Selecione um tipo.</Box>)

    if (data?.estado === null)
        response.push(<Box>Selecione um estado.</Box>)

    if (data?.municipios_saved.length === 0)
        response.push(<Box>Selecione um município.</Box>)

    if (response.length === 0)
        return ''

    return (response)
}

export default validateData